import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { Box } from "@mui/system";
import { colors, fontSizes } from "../theme";
import { commonSlice, store } from "../store";

interface Props {
    errorMessage: string[] | null;
}

export const ErrorDialog: React.FC<Props> = (props: Props) => {
    const handleClose = () => {
        store.dispatch(commonSlice.actions.setErrorMessage(null));
    };

    const result: JSX.Element[] = [];

    const messageExists = !!props.errorMessage?.length;

    if (messageExists && props.errorMessage) {
        const items = props.errorMessage.map((mes, i) => (
            <li key={i}>{mes}</li>
        ));
        result.push(
            <Box>
                <ul>{items}</ul>
            </Box>
        );
    }

    return (
        <Box id="ErrorDialog" sx={{ zIndex: 5000 }}>
            <Dialog
                open={messageExists}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box
                    sx={{
                        fontWeight: "bold",
                        fontSize: fontSizes.large,
                        pt: 4,
                        pl: 6,
                        pr: 6,
                    }}
                >
                    <Box>{result}</Box>
                    <Box
                        onClick={handleClose}
                        sx={{
                            color: colors.green.main,
                            textAlignLast: "right",
                            pb: 5,
                            pl: 6,
                            pr: 6,
                            cursor: "pointer",
                        }}
                    >
                        OK
                    </Box>
                </Box>
            </Dialog>
        </Box>
    );
};
